const initialState = {}

const menuesReducer = (state = initialState, action) => {
//    console.log('menuesReducer called with: ', state.menues, action)
    switch (action.type) {
        case 'menues/MenuesReplaced':
            return {...state, ...action.payload};
        default:
            return state;
    }
}

export default menuesReducer;